export const INTEGRATION_NAME_PROCESSING = 'DEPLOYMENT_INTEGRATION_PROCESSING';
export const INTEGRATION_NAME_PROCESSING_ERROR = 'DEPLOYMENT_INTEGRATION_PROCESSING_ERROR';
export const delimiterLabels = [
    {
        delimiter: '-',
        description: 'Use "-". Your generated deploy URL will be "*-ze.your.domain"'
    },
    {
        delimiter: '.',
        description: 'Use ".". Your generated deploy URL will be "*.ze.your.domain"'
    }
];
